import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function advancedQuery(data) {
  return request({
    url: URL.price.fbaQuotation.advancedQuery,
    method: 'post',
    data
  })
}

// 删除报价单
export function remove(requestBody) {
  return request({
    url: URL.price.fbaQuotation.remove,
    method: 'post',
    data: requestBody
  })
}

// 加载FbaQuotation的关联实体信息
export function loadFbaQuotationRelated(data) {
  return request({
    url: URL.price.fbaQuotation.loadQuotationRelated,
    method: 'post',
    data
  })
}

// 查询运价级别关联的客户
export function searchCustomerPrice(requestBody) {
  return request({
    url: URL.price.fbaQuotation.searchCustomerPrice,
    method: 'post',
    data: requestBody
  })
}

// 保存报价单
export function save(data) {
  return request({
    url: URL.price.fbaQuotation.save,
    method: 'post',
    data
  })
}

// 批量导入报价单
export function batchImportQuotation(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.price.fbaQuotation.batchImportQuotation,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

